import PopUp from "@components/molecules/PopUp";
import { ConfirmationPopupProps } from "./types";
import { ButtonCategory, ButtonType } from "../Button/types";

const ConfirmationPopup = ({
  title,
  htmlMessage,
  primaryButtonTitle,
  secondaryButtonTitle,
  primaryButtonAction,
  secondaryButtonAction,
  primaryButtonLoading = false,
  primaryButtonDisabled = false,
  messageType,
  category,
  styleKey = "Body-R",
  primaryButtonType = ButtonType.primary,
  secondaryButtonType = ButtonType.secondary,
  colorKey,
  opened = false,
}: ConfirmationPopupProps) => {
  const buttons = [
    {
      type: primaryButtonType,
      title: primaryButtonTitle,
      category: category ? (category as ButtonCategory) : undefined,
      onPressAction: primaryButtonAction,
      loading: primaryButtonLoading,
      disabled: primaryButtonDisabled,
    },
  ];

  if (secondaryButtonTitle) {
    buttons.push({
      type: secondaryButtonType,
      category: category ? (category as ButtonCategory) : undefined,
      title: secondaryButtonTitle,
      onPressAction: secondaryButtonAction ?? (() => {}),
      loading: false,
      disabled: false,
    });
  }
  if (!opened) {
    return null;
  }
  return (
    <PopUp
      title={title}
      buttons={buttons}
      HtmlSource={{
        html: htmlMessage,
      }}
      styleKey={styleKey}
      type={messageType}
      colorKey={colorKey}
    />
  );
};

export default ConfirmationPopup;
